"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaults = exports.VERSION = void 0;
exports.extractQuotedText = extractQuotedText;
exports.parseParams = parseParams;
exports.render = render;
exports.render_and_extract_attachments = render_and_extract_attachments;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VERSION = '0.4.0-bobtv-1.1',
  // default options
  defaults = {
    showQuotePrefix: true,
    classPrefix: 'bbcode_',
    mentionPrefix: '@'
  };

// copied from here:
// http://blog.mattheworiordan.com/post/13174566389/url-regular-expression-for-links-with-or-without-the had to make an
// update to allow / in the query string, since some sites will have a / there made another update to support colons in
// the query string made another update to disallow an ending dot(.)
exports.defaults = defaults;
exports.VERSION = VERSION;
var URL_PATTERN = new RegExp("(" // overall match
+ "(" // brackets covering match for protocol (optional) and domain
+ "([A-Za-z]{3,9}:(?:\\/\\/)?)" // allow something@ for email addresses
+ "(?:[\\-;:&=\\+\\$,\\w]+@)?[A-Za-z0-9\\.\\-]+[A-Za-z0-9\\-]"
// anything looking at all like a domain, non-unicode domains
+ "|" // or instead of above
+ "(?:www\\.|[\\-;:&=\\+\\$,\\w]+@)" // starting with something@ or www.
+ "[A-Za-z0-9\\.\\-]+[A-Za-z0-9\\-]" // anything looking at all like a domain
+ ")" // end protocol/domain
+ "(" // brackets covering match for path, query string and anchor
+ "(?:\\/[\\+~%\\/\\.\\w\\-_]*)?" // allow optional /path
+ "\\??(?:[\\-\\+=&;%@\\.\\w_\\/:]*)" // allow optional query string starting with ?
+ "#?(?:[\\.\\!\\/\\\\\\w]*)" // allow optional anchor #anchor
+ ")?" // make URL suffix optional
+ ")");
function doReplace(content, matches, options) {
  var i, obj, regex, hasMatch, tmp;
  // match/replace until we don't change the input anymore
  do {
    hasMatch = false;
    for (i = 0; i < matches.length; ++i) {
      obj = matches[i];
      regex = new RegExp(obj.e, 'gi');
      tmp = content.replace(regex, obj.func.bind(undefined, options));
      if (tmp !== content) {
        content = tmp;
        hasMatch = true;
      }
    }
  } while (hasMatch);
  return content;
}
function listItemReplace(options, fullMatch, tag, value) {
  return '<li>' + value.trim() + '</li>';
}
function extractQuotedText(value, parts) {
  var quotes = ["\"", "'"],
    i,
    quote,
    nextPart;
  for (i = 0; i < quotes.length; ++i) {
    quote = quotes[i];
    if (value && value[0] === quote) {
      value = value.slice(1);
      if (value[value.length - 1] !== quote) {
        while (parts && parts.length) {
          nextPart = parts.shift();
          value += " " + nextPart;
          if (nextPart[nextPart.length - 1] === quote) {
            break;
          }
        }
      }
      value = value.replace(new RegExp("[" + quote + "]+$"), '');
      break;
    }
  }
  return [value, parts];
}
function parseParams(tagName, params) {
  var parts,
    rv,
    part,
    index,
    paramMap = {};
  if (!params) {
    return paramMap;
  }

  // first, collapse spaces next to equals
  params = params.replace(/\s*[=]\s*/g, "=");
  parts = params.split(/\s+/);
  while (parts.length) {
    part = parts.shift();
    // check if the param itself is a valid url
    if (!URL_PATTERN.exec(part)) {
      index = part.indexOf('=');
      if (index > 0) {
        rv = extractQuotedText(part.slice(index + 1), parts);
        paramMap[part.slice(0, index).toLowerCase()] = rv[0];
        parts = rv[1];
      } else {
        rv = extractQuotedText(part, parts);
        paramMap[tagName] = rv[0];
        parts = rv[1];
      }
    } else {
      rv = extractQuotedText(part, parts);
      paramMap[tagName] = rv[0];
      parts = rv[1];
    }
  }
  return paramMap;
}
function tagReplace(options, fullMatch, tag, params, value) {
  var tmp, className, inlineValue, i, val;
  tag = tag.toLowerCase();
  params = parseParams(tag, params || undefined);
  inlineValue = params[tag];
  switch (tag) {
    case 'center':
      return '<div style="text-align: center">' + value + '</div>';
    /*
    case 'quote':
        val = '<div class="' + options.classPrefix + 'quote"';
        for (i in params) {
            tmp = params[i];
            if (!inlineValue && (i === 'author' || i === 'name')) {
                inlineValue = tmp;
            } else if (i !== tag) {
                val += ' data-' + i + '="' + tmp + '"';
            }
        }
        return val + '>' + (inlineValue ? inlineValue + ' wrote:' : (options.showQuotePrefix ? 'Quote:' : '')) + '<blockquote>' + value + '</blockquote></div>';
    case 'url':
        return '<a class="' + options.classPrefix + 'link" target="_blank" href="' + (inlineValue || value) + '">' + value + '</a>';
    case 'email':
        return '<a class="' + options.classPrefix + 'link" target="_blank" href="mailto:' + (inlineValue || value) + '">' + value + '</a>';
    case 'anchor':
        return '<a name="' + (inlineValue || params.a || value) + '">' + value + '</a>';
    */
    case 'b':
      return '<strong>' + value + '</strong>';
    case 'i':
      return '<em>' + value + '</em>';
    case 'u':
      return '<u>' + value + '</u>';
    case 's':
      return '<s>' + value + '</s>';
    case 'font':
      return '<span style="font-family: ' + (options.fontFamilies[inlineValue] || options.defaultFontFamily) + '">' + value + '</span>';
    case 'size':
      return '<span style="font-size: ' + inlineValue + '%">' + value + '</span>';
    case 'color':
      return '<span style="color: ' + inlineValue + '">' + value + '</span>';
    /*
    case 'indent':
        return '<blockquote>' + value + '</blockquote>';
    */
    case 'list':
      tag = 'ul';
      className = options.classPrefix + 'list';
      if (inlineValue && /[1Aa]/.test(inlineValue)) {
        tag = 'ol';
        if (/1/.test(inlineValue)) {
          className += '_numeric';
        } else if (/A/.test(inlineValue)) {
          className += '_alpha';
        } else if (/a/.test(inlineValue)) {
          className += '_alpha_lower';
        }
      }
      val = '<' + tag + ' class="' + className + '">';
      //  parse the value
      var listInside = doReplace(value, [{
        e: '\\[([*])\\]([^\r\n\\[\\<]+)',
        func: listItemReplace
      }], options);
      val += listInside.replace(/\r\n/g, '');
      return val + '</' + tag + '>';
    /*
    case 'code':
    case 'php':
    case 'java':
    case 'javascript':
    case 'cpp':
    case 'ruby':
    case 'python':
        return '<pre class="' + options.classPrefix + (tag === 'code' ? '' : 'code_') + tag + '">' + value + '</pre>';
    case 'highlight':
        return '<span class="' + options.classPrefix + tag + '">' + value + '</span>';
    case 'html':
        return value;
    case 'span':
    case 'h1':
    case 'h2':
    case 'h3':
    case 'h4':
    case 'h5':
    case 'h6':
        return '<' + tag + '>' + value + '</' + tag + '>';
    case 'youtube':
        return '<object class="' + options.classPrefix + 'video" width="425" height="350"><param name="movie" value="http://www.youtube.com/v/' + value + '"></param><embed src="http://www.youtube.com/v/' + value + '" type="application/x-shockwave-flash" width="425" height="350"></embed></object>';
    case 'gvideo':
        return '<embed class="' + options.classPrefix + 'video" style="width:400px; height:325px;" id="VideoPlayback" type="application/x-shockwave-flash" src="http://video.google.com/googleplayer.swf?docId=' + value + '&amp;hl=en">';
    case 'google':
        return '<a class="' + options.classPrefix + 'link" target="_blank" href="http://www.google.com/search?q=' + (inlineValue || value) + '">' + value + '</a>';
    case 'wikipedia':
        return '<a class="' + options.classPrefix + 'link" target="_blank" href="http://www.wikipedia.org/wiki/' + (inlineValue || value) + '">' + value + '</a>';
    */
    case 'img':
      var dims = new RegExp('^(\\d+)x(\\d+)$').exec(inlineValue || '');
      if (!dims || dims.length !== 3) {
        dims = new RegExp('^width=(\\d+)\\s+height=(\\d+)$').exec(inlineValue || '');
      }
      if (dims && dims.length === 3) {
        params = undefined;
      }
      val = '<img class="' + options.classPrefix + 'image" src="' + value + '"';
      if (dims && dims.length === 3) {
        val += ' width="' + dims[1] + '" height="' + dims[2] + '"';
      } else {
        for (i in params) {
          tmp = params[i];
          if (i === 'img') {
            i = 'alt';
          }
          val += ' ' + i + '="' + tmp + '"';
        }
      }
      return val + '/>';
    case 'attachments':
      if (options.extractAttachments) return '' + value + '';
      return '<div class="attachments">' + value + '</div>';
    case 'attachment':
      var fancyboxGallery = "";
      if (options.fancyboxGallery) {
        fancyboxGallery = ' data-fancybox-group="' + options.fancyboxGallery + '" ';
      }
      if (!options.attachments) {
        options.attachments = [];
      }
      if (options.extractAttachments) {
        var url = decodeURIComponent(params.url);
        var thumbnail_url = decodeURIComponent(params.thumbnail_url);
        options.attachments.push(_objectSpread(_objectSpread({}, params), {}, {
          url: url,
          thumbnail_url: thumbnail_url
        }));
        return '';
      }
      return '<a href="' + decodeURIComponent(params.url) + '" class="fancybox" ' + fancyboxGallery + '"><img class="' + options.classPrefix + 'image attachment" src="' + decodeURIComponent(params.thumbnail_url) + '"/></a>';
    case 'mention':
      var mentionClass = options.currentNick === value ? "mention-me" : "mention";
      if (typeof options.mentionCB == 'function') options.mentionCB(value);
      return ' <span class="' + mentionClass + '">' + value + '</span>';
  }
  // return the original
  return fullMatch;
}

/**
 * Renders the content as html
 * @param content   the given content to render
 * @param options   optional object with control parameters
 * @returns rendered html
 */
function render(content, options) {
  var matches = [],
    tmp;
  options = options || {};
  for (tmp in defaults) {
    if (!Object.prototype.hasOwnProperty.call(options, tmp)) {
      options[tmp] = defaults[tmp];
    }
  }
  // for now, only one rule
  matches.push({
    e: '\\[(\\w+)(?:[= ]([^\\]]+))?]((?:.|[\r\n])*?)\\[/\\1]',
    func: tagReplace
  });
  return doReplace(content, matches, options);
}
function render_and_extract_attachments(content, options) {
  var matches = [],
    tmp;
  options = options || {
    extractAttachments: extractAttachments,
    attachments: []
  };
  for (tmp in defaults) {
    if (!Object.prototype.hasOwnProperty.call(options, tmp)) {
      options[tmp] = defaults[tmp];
    }
  }
  // for now, only one rule
  matches.push({
    e: '\\[(\\w+)(?:[= ]([^\\]]+))?]((?:.|[\r\n])*?)\\[/\\1]',
    func: tagReplace
  });
  var text = doReplace(content, matches, options);
  return {
    text: text,
    attachments: options.attachments
  };
}